// extracted by mini-css-extract-plugin
var _1 = "_Hh8Ob";
export { _1 as "confirmationModal" }
